import { validateResponseHasSchema } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'
import { z } from 'zod'
import { AssetType } from '@/features/assets/constants'

const client = createAssetManagementClient()

export const checkAssetCreationEligibility = (unifiiProjectCode: number, assetType: AssetType, wheelingExternalKey?: string) => validateResponseHasSchema(
  client.sendGet(`v2/assets/create/eligibility`, { unifiiProjectCode, type: assetType, wheelingExternalKey }),
  z.object({
    data: z.object({
      unifiiProjectCode: z.number(),
      wheelingExternalKey: z.string().nullable(),
      projectName: z.string(),
      projectAddress: z.string(),
      type: z.nativeEnum(AssetType),
      wheelingAllocationSize: z.number().nullable(),
    })
  })
).then(
  res => res.data
);
